import { createFileRoute } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import {
  CompanyScreen,
  type CompanyTab,
  companySearchSchema,
} from '../../../../features/companies/company-screen';

/**
 * Ecranul unei firme (#207). Tabul stă în `?tab=`, ca la fișa clientului: un refresh lasă
 * operatorul pe tabul pe care era.
 *
 * Permisiunea vine prin prefix de la `/setari/firme` (`companies.view`), fără intrare proprie.
 */
export const Route = createFileRoute('/_authenticated/setari/firme/$companyId')({
  validateSearch: companySearchSchema,
  component: FirmaPagina,
});

function FirmaPagina() {
  const { companyId } = Route.useParams();
  const { tab, spv, spvMessage } = Route.useSearch();
  const navigate = Route.useNavigate();

  // `replace`: schimbarea tabului nu e un pas în istoric — „Înapoi" duce la listă. Scoate și
  // rezultatul conectării la SPV din adresă (#200), ca un refresh să nu-l mai spună o dată.
  const onTabChange = useCallback(
    (next: CompanyTab) => navigate({ search: { tab: next }, replace: true }),
    [navigate],
  );
  const spvCallback = useMemo(
    () => (spv === undefined ? null : { outcome: spv, message: spvMessage }),
    [spv, spvMessage],
  );

  return (
    <CompanyScreen
      companyId={companyId}
      tab={tab}
      onTabChange={onTabChange}
      spvCallback={spvCallback}
    />
  );
}
